import React from "react";


const Impressum = () => {
  return (
    <div className="impressum-page text-center">
      <section className="impressum-hero">
        <h1 className="section-title">Impressum</h1>
        <p className="impressum-intro">
          Angaben gemäß § 5 TMG
        </p>
      </section>

      <section className="impressum-content">
        <p><strong>DomVault – Paul Hünecke</strong></p>
        <p>Dessauer Str. 4a<br />39114 Magdeburg<br />Deutschland</p>

        <p>
          <strong>Kontakt:</strong><br />
          E-Mail: <a href="mailto:info.domvault@gmail.com" className="contact-link">info.domvault@gmail.com</a><br />
          Website: <a href="https://www.domvault.de" target="_blank" rel="noopener noreferrer" className="contact-link">www.domvault.de</a>
        </p>

        <p>
          <strong>Umsatzsteuer-ID:</strong><br />
          DE123456789 (Beispiel)
        </p>

        <p>
          <strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</strong><br />
          Paul Hünecke, Anschrift wie oben
        </p>

        <p>
          <strong>Haftungsausschluss:</strong><br />
          Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit,
          Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr übernommen werden.
        </p>

        <p>
          <strong>Online-Streitbeilegung:</strong><br />
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br></br>
          <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="contact-link">
            https://ec.europa.eu/consumers/odr/
          </a>
        </p>
      </section>

      <footer className="footer text-center">
        <p>© 2025 DomVault – The Vault for Valuable Names.</p>
      </footer>
    </div>
  );
};

export default Impressum;
